// extracted by mini-css-extract-plugin
export var awardIconStyle = "award_item-module--awardIconStyle--6rtvz";
export var awardItemWrapperStyle = "award_item-module--awardItemWrapperStyle--JJquA";
export var awardTitleStyle = "award_item-module--awardTitleStyle--2IMXP";
export var awardsSectionItemStyle = "award_item-module--awardsSectionItemStyle--quo-n";